var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dollarsign",
    stroke: "#141414",
    strokeWidth: 1.33333333
  }, /*#__PURE__*/React.createElement("g", {
    id: "dollar-sign",
    transform: "translate(5.000000, 1.700000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 0,
    x2: 4,
    y2: 14.666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333333,2.66666673 L2.33333333,2.66666673 C1.04466892,2.66666673 0,3.71133567 0,5.00000011 C0,6.28866456 1.04466892,7.3333335 2.33333333,7.3333335 L5.66666667,7.3333335 C6.95533106,7.33333353 8,8.37800246 8,9.66666673 C8,10.9553313 6.95533106,12.0000003 5.66666667,12.0000003 L0,12.0000003",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.00013177ea03d399198a8f2273f79925.svg";
export { ForwardRef as ReactComponent };